import styles from './styles.module.scss';

export const TagCount = ({ count }) => (
  <span className={styles.tagCountContainer}>
    <div className={styles.countContainer}>{count}</div>
    <div className={styles.pointer}></div>
  </span>
);
